import { LocalizationService } from '@abp/ng.core';
import { ToasterService } from '@abp/ng.theme.shared';
import { Component, Injector, OnInit } from '@angular/core';
import { take } from 'rxjs';
import { NotificationType } from 'src/core/decorators/notification/notification-type.decorator';
import { NotificationDto } from 'src/core/models/notification/notification.dto';
import { NotificationService } from 'src/core/services/notification/notification.service';
import { CAToasterHelperService } from 'src/core/services/toaster/ca-toaster-helper.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FeedbackDetailComponent } from '../../feedback-detail/feedback-detail.component';
@Component({
  selector: 'ca-feedback-notification',
  templateUrl: './feedback-notification.component.html',
  styleUrls: ['./feedback-notification.component.scss'],
  standalone: false,
})
@NotificationType('FeedbackNotification', FeedbackNotificationComponent)
export class FeedbackNotificationComponent implements OnInit {
  data: NotificationDto;

  constructor(private notificationService: NotificationService, private modalService: NgbModal) {}

  get senderName(): string {
    return this.data ? JSON.parse(this.data.payload).senderName : '';
  }

  get feedbackId(): number {
    return this.data ? JSON.parse(this.data.payload).feedbackId : 0;
  }

  get notificationId(): string {
    return this.data?.id ?? '';
  }
  get markedAsRead(): boolean {
    return this.data?.markedAsRead ?? true;
  }

  ngOnInit(): void {}

  openFeedbackDetail(feedbackId: number, notificationId?: string): void {
    const modalRef = this.modalService.open(FeedbackDetailComponent, {
      scrollable: false,
      centered: true,
      windowClass: 'feedback-modal',
    });
    modalRef.componentInstance.feedbackId = feedbackId;
    const id = notificationId || this.notificationId;

    if (id && !this.markedAsRead) {
      this.notificationService.markAsRead(id).subscribe();
    }
  }

  static showNotification(
    notificationId: string,
    payload: string,
    toastr: ToasterService,
    localizationService: LocalizationService,
    toasterHelperService: CAToasterHelperService,
    notificationService: NotificationService,
    injector: Injector
  ) {
    const parsedPayload = JSON.parse(payload);
    const message = localizationService.instant('::Feedback:Received', parsedPayload.senderName);
    var toastrId = toastr.info(message);

    var toastrInstance = toasterHelperService.getToastById(toastrId);
    toastrInstance.onTap.pipe(take(1)).subscribe(() => {
      this.toasterClickedHandler(injector, notificationService, notificationId, parsedPayload);
    });
  }

  static toasterClickedHandler(
    injector: Injector,
    notificationService: NotificationService,
    notificationId: string,
    payload: any
  ): void {
    const cmp = injector.get(FeedbackNotificationComponent);
    cmp.openFeedbackDetail(payload.feedbackId, notificationId);
    notificationService.markAsRead(notificationId).subscribe();
  }
}
